export const UPDATE_MESSAGE_START = 'UPDATE_MESSAGE_START'
export const UPDATE_MESSAGE_SUCCESS = 'UPDATE_MESSAGE_SUCCESS'
export const UPDATE_MESSAGE_FAIL = 'UPDATE_MESSAGE_FAIL'
